module.exports = __webpack_public_path__ + "img/5.942ab5e8.png";